const state = {
	jwt: null,
	refresh: null,
	expires: null,
	id: null,
	permissions: {},
	featureFlags: {},
	me: null,
}

const TRESHOLD = 30000

const getters = {
	getToken(currentState) {
		return currentState.jwt
	},
	getRefreshToken(currentState) {
		return currentState.refresh
	},
	getExpirationSeconds(currentState) {
		return currentState.expires - Date.now() - TRESHOLD
	},
	canRefresh(currentState) {
		return !!currentState.refreshToken
	},
	isExpired(currentState) {
		return !currentState.expires || new Date(currentState.expires - TRESHOLD) < new Date()
	},
	isAuth(currentState) {
		return currentState.jwt !== null && currentState.refresh !== null
	},
	isLoaded(currentState) {
		return currentState.jwt !== null && currentState.me !== null
	},
	isAuthorized(currentState) {
		return (access) => {
			const [resource, permission] = access.split('.')
			const userPermission = currentState.permissions['*'] || currentState.permissions[resource]

			return typeof userPermission === 'object'
				? userPermission[permission] : userPermission === true
		}
	},
	isFeatureFlagActive(currentState) {
		return (flag) => {
			const isActive = currentState.featureFlags[flag]
			if (typeof isActive === 'undefined') {
				console.warn(`Feature flag ${flag} not found`)
				return true
			}

			return isActive
		}
	},
	me(currentState) {
		return currentState.me
	},
}

const actions = {
	login({ commit }, { jwt, expires }) {
		commit('setJWT', jwt)
		commit('setExpiration', expires)
	},
	authenticate({ commit }, { accessToken, refreshToken }) {
		commit('setJWT', accessToken)
		commit('setRefresh', refreshToken)
	},
	refresh({ commit }, { accessToken }) {
		commit('setJWT', accessToken)
	},
	identify({ commit }, identity) {
		commit('setPermissions', identity.permissions)
		commit('setExpiration', identity._expires * 1000)
		commit('setMe', identity)
	},
	setFeatureFlags({ commit }, featureFlags) {
		commit('setFeatureFlags', featureFlags)
	},
	logout({ commit }) {
		commit('setJWT', null)
		commit('setRefresh', null)
		commit('setExpiration', null)
		commit('setMe', null)
		commit('setID', null)
		commit('setPermissions', {})
	},
}

const mutations = {
	setJWT(currentState, jwt) {
		currentState.jwt = jwt
	},
	setRefresh(currentState, refresh) {
		currentState.refresh = refresh
	},
	setExpiration(currentState, expires) {
		currentState.expires = expires
	},
	setPermissions(currentState, permissions) {
		currentState.permissions = permissions
	},
	setID(currentState, id) {
		currentState.id = id
	},
	setMe(currentState, me) {
		currentState.me = me
	},
	setFeatureFlags(currentState, featureFlags) {
		currentState.featureFlags = featureFlags
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}
